import { createApiSlice } from "@common";
import {
    FETCH_PROJECT_BY_ACCOUNT
} from "@routes";

// Define the API config array
const apiConfig = [
    {
        name: "getProjectWithAccount",
        method: "get",
        url: FETCH_PROJECT_BY_ACCOUNT,
        stateKey: "accountProjectData",
    },
];

// Define custom reducers and their initial state
const customReducers = {
    initialState: {
        additionalData: [],
        accountProjectData: [],
        selectedProject: {},
        selectedWorkSpace: {},
    },
    reducers: {
        setAdditionalData: (state, action) => {
            state.additionalData = action.payload;
        },
        projectRowSelect: (state, action) => {
            state.selectedProject =
                action.payload.length > 0 ? action.payload[0] : null;
        },
        workSpaceRowSelect: (state, action) => {
            state.selectedWorkSpace =
                action.payload.length > 0 ? action.payload[0] : null;
        },
    },
};

// Generate the slice, thunks, and actions using the utility function
const { slice, thunks, actions } = createApiSlice(
    "customerAccount",
    apiConfig,
    customReducers
);
const customerAccountSlice = slice;
// Export the slice's reducer
export default customerAccountSlice.reducer;

// Destructure and export thunks directly from thunksExports
export const {
    getProjectWithAccount
} = thunks;

// Destructure and export actions directly from actionsExports
export const { rowSelect, projectRowSelect, } =
    actions;
